export default __webpack_public_path__ + "static/media/paypal.598c4c14.svg";